module.exports = __webpack_public_path__ + "img/diente_solid.f51cccd3.svg";